// Are we running inside the OniKanji Android app (a Trusted Web Activity)?
//
// The app opens the site at /home?source=android_app (twa-manifest startUrl),
// and Android sets document.referrer to android-app://<package> on launch.
// We remember it in sessionStorage, not localStorage: the app shares Chrome's
// storage, so a lasting flag would also hide purchases on the regular website.
//
// Inside the app, Google Play rules don't allow our Stripe checkout, so every
// purchase entry point checks isAndroidApp() until Play Billing is added.
export const ANDROID_PACKAGE = 'com.onikanji.app';
const KEY = 'onikanji_android_app';

export function captureAppContext() {
    try {
        const params = new URLSearchParams(window.location.search);
        const fromApp = params.get('source') === 'android_app' ||
            document.referrer.startsWith(`android-app://${ANDROID_PACKAGE}`);
        if (fromApp) sessionStorage.setItem(KEY, '1');
    } catch (e) {
        /* storage blocked: treat as the website */
    }
}

export function isAndroidApp() {
    try {
        return sessionStorage.getItem(KEY) === '1';
    } catch (e) {
        return false;
    }
}

// Running as an installed app (the Android app, or added to the home screen)
// rather than in a browser tab. Installed apps get no website footer; its links
// live at the bottom of the menu instead.
export function isInstalledApp() {
    if (isAndroidApp()) return true;
    try {
        return window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone === true;
    } catch (e) {
        return false;
    }
}
